// src/Robot.js
import React, { useEffect, useState } from 'react';
import './Robot.css';

const Robot = () => {
  const [animationEnded, setAnimationEnded] = useState(false);

  useEffect(() => {
    const handleAnimationEnd = () => {
      setAnimationEnded(true);
    };

    const robot = document.querySelector('.robot');
    robot.addEventListener('animationend', handleAnimationEnd);

    return () => {
      robot.removeEventListener('animationend', handleAnimationEnd);
    };
  }, []);

  return (
    <>
    <div className={`robot ${animationEnded ? 'stay' : ''}`}>
        
        <img src="/robot.png" alt="hi" width={"200px"} />
      </div>
    </>
    
    
  );
};

export default Robot;
